import ArrowBack from '@mui/icons-material/ArrowBack'
import { IconButton } from '@mui/material'
import { useNavigate } from 'react-router'
import React from 'react'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'

export default function PrescriptionViewPageHeading({
  clinicLocationOptions,
  mentorClinicAssociationData,
  clinicId,
}) {
  const navigate = useNavigate()
  return (
    <div className="d-flex align-items-center gap-1 fs-6">
      <IconButton
        onClick={() => {
          navigate('/mentor-home/prescription-templates')
        }}
      >
        <ArrowBack />
      </IconButton>
      <div className="d-flex align-items-center gap-2 w-100">
        <div className="flex-grow-1">
          {/* This should select clinic location */}
          <CustomSelect
            onChangeEvent={(e) => {
              navigate('/mentor-home/prescription-templates/' + e.target.value?.id)
            }}
            options={clinicLocationOptions}
            value={
              mentorClinicAssociationData?.find((association) => association?.id === clinicId) ||
              null
            }
            id="presc-template"
            selectType={selectTypes?.object}
            getOptionLabel={(option) => option?.title || '--'}
            getOptionValue={(option) => {
              return option?.id || ''
            }}
            // components={{
            //   Option: CustomOption,
            //   SingleValue: CustomSingleValue,
            // }}
          />
        </div>
        {/* <div className="d-flex align-items-center gap-1 flex-shrink-0">
                  <Button variant="contained" size="small" onClick={createPrescriptionTemplate}>
                    Create New
                  </Button>
                  <Button variant="outlined" size="small" color="error" onClick={handleDelete}>
                    Delete
                  </Button>
                </div> */}
      </div>
    </div>
  )
}
